/**
 * @fileoverview Standards/Skills toggle (left) + class selector (right).
 */

import { useMemo } from 'react'
import { Flex, SegmentedControl, Select } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import type { ReportClass, ReportType } from '../types'

interface DevelopmentReportFiltersProps {
  readonly classes: ReportClass[]
  readonly type: ReportType
  readonly classId: string
  readonly onTypeChange: (type: ReportType) => void
  readonly onClassChange: (id: string) => void
  readonly disabled?: boolean
}

const SELECT_STYLE = { minWidth: 220 }

export function DevelopmentReportFilters({
  classes,
  type,
  classId,
  onTypeChange,
  onClassChange,
  disabled = false,
}: DevelopmentReportFiltersProps) {
  const { t } = useTranslation()

  const classOptions = useMemo(() => classes.map(c => ({ value: c.id, label: c.name })), [classes])

  return (
    <Flex gap='sm' align='center' justify='space-between' wrap='wrap'>
      <SegmentedControl
        color='teal'
        value={type}
        onChange={value => onTypeChange(value as ReportType)}
        data={[
          { value: 'standards', label: t('development_report.toggle.standards') },
          { value: 'skills', label: t('development_report.toggle.skills') },
        ]}
        radius='xl'
      />
      <Select
        placeholder={t('development_report.filters.select_class')}
        data={classOptions}
        value={classId || null}
        onChange={value => onClassChange(value ?? '')}
        searchable
        clearable
        disabled={disabled}
        style={SELECT_STYLE}
      />
    </Flex>
  )
}
